import { Select } from '@brighterion/br-ui';
import clsx from 'clsx';
import { Field, FieldArrayRenderProps, FieldProps, useFormikContext } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getOperatorOptions } from '../helper';

import styles from './OperatorField.css';

type OperatorFieldProps = {
    arrayHelper: FieldArrayRenderProps;
    index: number;
    parameterType?: Parameter['parameterType'];
};

const OperatorField = ({ arrayHelper, index, parameterType }: OperatorFieldProps) => {
    const { t } = useTranslation();
    const { name, replace } = arrayHelper;
    const {
        values: { conditions }
    } = useFormikContext<NewRuleFormSchema>();
    const { parameterField } = conditions[index];

    return (
        <Field name={`${name}[${index}].operatorField`}>
            {({ field, form }: FieldProps) => {
                return (
                    <Select
                        size='sm'
                        type='search'
                        placeholder='- Select Operator -'
                        className={clsx(styles.operatorList, field.value.length < 1 && styles.unhighlight)}
                        searchInputPlaceholder='Search'
                        handleClickCallback={(value) => {
                            replace(index, {
                                ...conditions[index],
                                operatorField: value,
                                valueField: '',
                                valueType: ''
                            });
                            form.setFieldTouched(`${name}[${index}].valueField`, false);
                        }}
                        selectedItems={field.value}
                        disabled={form.isSubmitting}
                    >
                        {getOperatorOptions(parameterField.type, parameterType).map((op) => {
                            return (
                                <option key={op} value={op}>
                                    {t(`conditions.${op}`)}
                                </option>
                            );
                        })}
                    </Select>
                );
            }}
        </Field>
    );
};

export default React.memo(OperatorField);
